import React from 'react';
import classNames 	from 'classnames';
import Scroll from 'react-scroll';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-100475676-1');

let scrollPos = null;
class FloatPanel extends React.Component {
	constructor(props) {
    super(props);
    this.state = {
      premium: 52.1429,
      premiumDC: '',
      amountDC: '',
      premiumTPD: '',
      amountTPD: '',
      premiumIP: '',
      amountIP: '',
			show: true,
			showOnlyOne: false,
			showJustTwo: false,
			showAllThree: false
    };

    this.handlePremiumChange = this.handlePremiumChange.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
  }

	componentDidMount() {

		if(this.state.show === true) {
			let Events = Scroll.Events;
			let that = this;
			that.timer = setTimeout(function() {
				scrollPos = window.pageYOffset;
				window.addEventListener("scroll", that.handleScroll);
			}, 1000);
		}
	}

	componentWillUnmount() {
		let that = this;
		window.removeEventListener('scroll', that.handleScroll);
	}

	handleScroll() {
		if(this.props.DCamount > 1 && this.props.IPamount > 1 && this.props.TPDamount > 1) {
			if(window.pageYOffset > 735 && window.pageYOffset < 1365 && window.innerWidth >= 1024) {
				this.setState({
					show: true,
					showOnlyOne: false,
					showOnlyTwo: false,
					showAllThree: true
				});
			} else if(window.pageYOffset < 735 && window.innerWidth >= 1024) {
				this.setState({
					show: true,
					showOnlyOne: true,
					showOnlyTwo: false,
					showAllThree: false
				});
			} else if(window.pageYOffset > 1365 && window.innerWidth >= 1024) {
				this.setState({
					show: true,
					showOnlyOne: false,
					showOnlyTwo: true,
					showAllThree: false
				});
			}

		} else if(this.props.DCamount > 1 && this.props.TPDamount == '' && this.props.IPamount == '') {
			this.setState({showOnlyOne: true});
		} else if(this.props.DCamount == '' && this.props.TPDamount > 1 && this.props.IPamount == '') {
			this.setState({showOnlyOne: true});
		} else if(this.props.DCamount == '' && this.props.TPDamount == '' && this.props.IPamount > 1) {
			this.setState({showOnlyOne: true});
		} else if ((this.props.DCamount > 1 && this.props.TPDamount > 1 && this.props.IPamount == '') || (this.props.DCamount == '' && this.props.TPDamount > 1 && this.props.IPamount > 1) || (this.props.DCamount > 1 && this.props.TPDamount == '' && this.props.IPamount > 1)) {

			if(window.pageYOffset > 735 && window.pageYOffset < 1036 && window.innerWidth >= 1024) {
				this.setState({
					show: true,
					showOnlyOne: false,
					showOnlyTwo: false,
					showJustTwo: true
				});
			} else if(window.pageYOffset < 735 && window.innerWidth >= 1024) {
				this.setState({
					show: true,
					showOnlyOne: true,
					showOnlyTwo: false
				});
			} else if(window.pageYOffset > 1036 && window.innerWidth >= 1024) {
				this.setState({
					show: true,
					showOnlyOne: false,
					showOnlyTwo: true
				});
			}
		}
	}

  handlePremiumChange(e) {
    this.setState({
      premium: e.target.value
    },  () => {this.props.handlePremiumChange(this.state.premium);
    });
  }

  renderDCresults() {
		let DCamount = parseInt(this.props.DCamount).toLocaleString();
		let DCpremium = this.props.DCpremium;
		this.props.DCpremium != null ? DCpremium = DCpremium.toLocaleString(undefined, {minimumFractionDigits:2}) : null;

    if(this.props.DCpremium > 0) {
      return (
        <span className="results--panel-subcontent">
          <h5>Death</h5>
          <span className="results--panel--amount">${DCamount}</span>
          <span className="results--panel--premium">${DCpremium} {this.props.frequency}</span>
        </span>
      );
    }
  }

  renderTPDresults() {
		let TPDamount = parseInt(this.props.TPDamount).toLocaleString();
		let TPDpremium = this.props.TPDpremium;
		this.props.TPDpremium != null ? TPDpremium = TPDpremium.toLocaleString(undefined, {minimumFractionDigits:2}) : null;

    if(this.props.TPDpremium > 0) {
    return (
      <span className="results--panel-subcontent">
        <h5>Total and permanent disability</h5>
        <span className="results--panel--amount">${TPDamount}</span>
        <span className="results--panel--premium">${TPDpremium} {this.props.frequency}</span>
      </span>
    );
  }
  }

  renderIPresults() {
		let IPamount = parseInt(this.props.IPamount).toLocaleString();
		let IPpremium = this.props.IPpremium;
		this.props.IPpremium != null ? IPpremium = IPpremium.toLocaleString(undefined, {minimumFractionDigits:2}) : null;
    if(this.props.IPpremium > 0) {
    return (
    <span className="results--panel-subcontent">
      <h5>Income protection</h5>
      <span className="results--panel--amount">${IPamount} / month</span>
      <span className="results--panel--premium">${IPpremium} {this.props.frequency}</span>
			<span className="results--panel--subtext">({this.props.IPprotectionLength !== '65' ? 'for up to ' + this.props.IPprotectionLength + ' years' : 'until age ' + this.props.IPprotectionLength}, after a {this.props.insuranceCoverInputs.itemsWaitPeriod} day waiting period)</span>
    </span>
    );
	}
  }

  renderTotalresults() {
		let total = 0,
				refinedTotal=0,
				DCpremium= this.props.DCpremium || 0,
				TPDpremium= this.props.TPDpremium || 0,
				IPpremium= this.props.IPpremium || 0;

		if(this.props.DCpremium || this.props.TPDpremium || this.props.IPpremium) {
			DCpremium = parseFloat(this.props.DCpremium);
			TPDpremium = parseFloat(this.props.TPDpremium);
			IPpremium = parseFloat(this.props.IPpremium);

			DCpremium = DCpremium ? DCpremium : 0;
			TPDpremium = TPDpremium ? TPDpremium : 0;
			IPpremium = IPpremium ? IPpremium : 0;

			total = DCpremium + TPDpremium + IPpremium;
			refinedTotal = total.toFixed(2);
			return refinedTotal.toLocaleString(undefined, {minimumFractionDigits:2});
		}
  }

	handlePrint(e) {
    e.preventDefault();
    ReactGA.event({
      category: 'Your premium estimate',
      action: 'User clicked print estimate button'
    });
    window.print();
  }


render() {
		let showSticky = false,
				showStuckTop = false,
				showStuckBottom = false,
				showTwo = false,
				showThree = false;

		if (this.state.showOnlyOne) {
			showStuckTop = true;
		}

		if(this.state.showJustTwo) {
				showTwo = true;
		}

		if (this.state.showOnlyTwo) {
			showStuckBottom = true;
		}

		if (this.state.showAllThree) {
			showThree = true;
		}

		if (this.state.show) {
			showSticky = true;
		}

		let stickyClasses = {
			'is-shown' : showSticky,
			'show-three' : showThree,
			'show-two' : showTwo,
			'is-stuck-top' : showStuckTop,
			'is-stuck-bottom' : showStuckBottom
		};

    return (

			<div className={classNames('results-panel', stickyClasses)}>
        <div className="results-panel--content">
				<div className="results-panel-headings">
					<h5>Summary</h5>
					<span className="cover-heading">Cover</span>
					<span className="premium-heading">Estimated premium</span>
				</div>
          {this.renderDCresults()}
          {this.renderTPDresults()}
          {this.renderIPresults()}
        </div>
        <div className="results-panel--footer">
					<div className="results-panel--total">Total: <span className="price">${this.renderTotalresults()}</span>
				</div>
          <select value={this.props.premium} onChange={this.handlePremiumChange}>
            <option value="52.1429">Weekly</option>
            <option value="26.0715">Fortnightly</option>
            <option value="12">Monthly</option>
            <option value="1">Yearly</option>
          </select>
        </div>
				<a href="#" className="print" onClick={this.handlePrint} >Print estimate</a>
			</div>

    );
  }
}

FloatPanel.defaultProps = {
	DCpremium: 0,
	TPDpremium: 0,
	IPpremium: 0
};

FloatPanel.propTypes = {
	// DCamount: React.PropTypes.string.isRequired,
	// DCpremium: React.PropTypes.number.isRequired,
	// TPDpremium: React.PropTypes.number.isRequired,
  // IPamount: React.PropTypes.string.isRequired,
	// IPpremium: React.PropTypes.number.isRequired,
  // TPDamount: React.PropTypes.string.isRequired,
	frequency: React.PropTypes.string.isRequired,
	handlePremiumChange: React.PropTypes.func.isRequired,
	IPprotectionLength: React.PropTypes.string,
	insuranceCoverInputs: React.PropTypes.object.isRequired

};

export default FloatPanel;



// WEBPACK FOOTER //
// ./src/components/panels/FloatPanel.js